import { gql } from '@apollo/client'

export const AuthenticatePartner = gql`
    mutation($federalTaxId: String!) {
        authenticatePartner(federalTaxId: $federalTaxId) {
            access_token
            refresh_token
        }
    }
`

export const PartnerSignInToken = gql`
    query partnerSignInToken($nanoId: String!) {
        partnerSignInToken(nanoId: $nanoId) {
            token
        }
    }
`
